// AutoSaveToast.js - 自动存档状态提示
import EventBus from './EventBus.js';

const AUTO_SAVE_EVENT = 'game:autoSaveStatus';

class AutoSaveToastClass {
    /**
     * @param {Phaser.Scene} scene
     */
    bindScene(scene) {
        this.scene = scene;
        this.text = null;
        this.hideTimer = null;

        if (this._unsubscribe) {
            this._unsubscribe();
        }

        this._unsubscribe = EventBus.on(AUTO_SAVE_EVENT, (payload) => {
            this.show(payload?.message || '已自动保存', payload?.success !== false);
        });
    }

    show(message, success = true) {
        if (!this.scene || !this.scene.cameras?.main) {
            return;
        }

        if (this.text) {
            this.text.destroy();
        }
        if (this.hideTimer) {
            this.hideTimer.remove(false);
        }

        const cam = this.scene.cameras.main;
        this.text = this.scene.add.text(cam.width - 20, cam.height - 20, message, {
            fontSize: '14px',
            fill: success ? '#88ff88' : '#ff8888',
            fontFamily: 'monospace',
            backgroundColor: '#000000aa',
            padding: { x: 8, y: 4 }
        });
        this.text.setOrigin(1, 1);
        this.text.setScrollFactor(0);
        this.text.setDepth(9999);

        this.hideTimer = this.scene.time.delayedCall(2500, () => {
            if (this.text) {
                this.text.destroy();
                this.text = null;
            }
        });
    }

    destroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
            this._unsubscribe = null;
        }
        if (this.text) {
            this.text.destroy();
            this.text = null;
        }
    }
}

export function emitAutoSaveStatus(message, success = true) {
    EventBus.emit(AUTO_SAVE_EVENT, { message, success });
}

const AutoSaveToast = new AutoSaveToastClass();
export default AutoSaveToast;
